<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("dashboard.gconsentdetail") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 md11 lg11>
            <v-card class="rounded-lg">
              <v-card-title class="bg-card"
                >{{ $t("dashboard.cor") }} <v-spacer></v-spacer>
                <!-- <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      fab
                      color="error"
                      @click="Fn_DownloadPdf"
                    >
                      <v-icon>mdi-file-pdf-box</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("consentform.pdf") }}</span>
                </v-tooltip> -->
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="mr-12">
                <v-layout row wrap ml-3 pa-1>
                  <v-flex v-if="$t('default') === 'th'" xs11 lg11
                    ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
                    <a v-on:click="Fn_DetailPolicy">{{ PolicyHeader }} </a>
                    <br />
                    <b>{{ $t("dashboard.org") }} :</b> {{ BusinessNameTh }}
                  </v-flex>
                  <v-flex v-else xs11 lg11
                    ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
                    <a v-on:click="Fn_DetailPolicy">{{ PolicyHeader }} </a>
                    <br />
                    <b>{{ $t("dashboard.org") }} :</b> {{ BusinessNameEng }}
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs11 lg11 pt-5 v-for="(item, index) in Consent" :key="index">
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ index + 1 }}. {{ $t("consentform.head") }}
                <b class="ml-2">{{ item.ConsentHeader }}</b>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap ml-3 pa-1>
                  <v-flex xs11 lg11>
                    <div class="pb-2">
                      <b> {{ $t("dashboard.status") }} </b>
                      <b v-if="item.Status === 'approve'" class="green--text">
                        {{ $t("dashboard.statusapp") }}</b
                      >
                      <b
                        v-else-if="item.Status === 'unapprove'"
                        class="red--text"
                      >
                        {{ $t("dashboard.statusreject") }}</b
                      >
                      <b
                        v-else-if="item.Status === 'wait'"
                        class="orange--text"
                      >
                        {{ $t("dashboard.statuspen") }}</b
                      >
                    </div>
                    <div class="pb-1">
                      <b>{{ $t("dashboard.detail") }}</b>
                    </div>
                    <div v-html="item.ConsentDetail"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogGeneralConsent
        :show="DialogGeneral"
        :_header="PolicyHeader"
        :_detail="PolicyDetail"
        @closeDialogDelete="DialogGeneral = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogGeneralConsent from "@/components/dialog/DialogGeneralConsentDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogGeneralConsent, OverlaySearch },
  data: function () {
    return {
      Consent: [],
      DataConsent: [],
      PolicyHeader: "",
      PolicyName: "",
      PolicyDetail: "",
      BusinessNameTh: "",
      BusinessNameEng: "",
      Status: "",
      loadingDownloadData: false,
      DialogGeneral: false,
    };
  },
  computed: {
    ...mapGetters(["DataGeneralConsent"]),
    ...mapGetters(["Business"]),
    _SendId: {
      get() {
        return this.DataGeneralConsent.SendId || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataPolicy();
  },
  methods: {
    async Fn_GetDataPolicy() {
      this.loadingDownloadData = true;
      var payload = {
        UserName: this.$cookies.get("OneUsername"),
        AccountId: this.$cookies.get("OneAccountId"),
        SendId: this._SendId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/GetConsentId",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataConsent = response.data.Message;
            this.Consent = response.data.Message.Consent;
            this.PolicyName = response.data.Message.Name;
            this.PolicyHeader = response.data.Message.PolicyHeader;
            this.PolicyDetail = response.data.Message.PolicyDetail;
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.BusinessNameEng = response.data.Message.BusinessNameEng;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") + error.message || error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push("/consent-list");
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
    async Fn_DownloadPdf() {
      this.loadingDownloadData = true;
      var payload = {
        UserName: this.$cookies.get("OneUsername"),
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessNameEng: this.DataConsent.BusinessNameEng,
        BusinessNameTh: this.DataConsent.BusinessNameTh,
        Consent: this.DataConsent.Consent,
        ConsentId: this.DataConsent.ConsentId,
        Email: this.DataConsent.Email,
        GroupId: this.DataConsent.GroupId,
        GroupName: this.DataConsent.GroupName,
        Name: this.DataConsent.Name,
        PolicyDetail: this.DataConsent.PolicyDetail,
        PolicyHeader: this.DataConsent.PolicyHeader,
        PolicyId: this.DataConsent.PolicyId,
        SendId: this.DataConsent.SendId,
        SourceSystem: this.DataConsent.SourceSystem,
        Tel: this.DataConsent.Tel,
        Type: this.DataConsent.Type,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "report/gennerate/pdf",
          { Data: dataEncode },
          { headers },
          { responseType: "arraybuffer" }
        )
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/pdf",
          });
          var DateTime = new Date().toISOString().slice(0, 10);
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "GeneralConsent" + DateTime + ".pdf";
          link.click();
          this.loadingDownloadData = false;

          //   if (response.data.Status === "OK") {
          //     let blob = new Blob([response.data], {
          //       type: "application/pdf",
          //     });
          //     let link = document.createElement("a");
          //     link.href = window.URL.createObjectURL(blob);
          //     link.download = "GeneralConsent.pdf";
          //     link.click();
          //   } else {
          //     Toast.fire({
          //       icon: "error",
          //       title: response.data.ErrorMessage,
          //     });
          //   }
          // })
          // .catch((error) => {
          //   this.loadingDownloadData = false;
          //   if (error.response) {
          //     Toast.fire({
          //       icon: "error",
          //       title: error.response.data.ErrorMessage,
          //     });
          //   } else if (error.request) {
          //     Toast.fire({
          //       icon: "error",
          //       title: error.request,
          //     });
          //   } else {
          //     Toast.fire({
          //       icon: "error",
          //       title: error.message || error,
          //     });
          //   }
        });
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
